// extracted by mini-css-extract-plugin
export default {"sidebar-wrapper":"style_sidebar-wrapper__dIsCP","icon":"style_icon__4PM4J"};